import styled, { css } from 'styled-components';

import { tokens } from '../../tokens';
import { NftCardHeroInteriorAlignment } from '../../types';

interface StyledInteriorProps {
    $alignment?: NftCardHeroInteriorAlignment;
}

const pageFrameBase = css`
    display: grid;
    justify-items: center;
    position: absolute;
    left: 0;
    right: 0;
`;

export const StyledHero = styled.div`
    --yat_nft-card-hero-interior-padding-top: ${tokens.hero.interior.padding}px;
    --yat_nft-card-hero-interior-padding-bottom: ${tokens.hero.interior.padding}px;

    z-index: ${tokens.hero.zindex.base};
    position: relative;
    display: grid;
    grid-template-rows: auto 1fr auto;
`;

export const StyledHeader = styled.header`
    ${pageFrameBase};
    --yat_nft-card-hero-interior-padding-bottom: auto;

    z-index: ${tokens.hero.zindex.header};
    top: 0;
`;

export const StyledFooter = styled.footer`
    ${pageFrameBase};
    --yat_nft-card-hero-interior-padding-top: auto;

    z-index: ${tokens.hero.zindex.footer};
    bottom: 0;
`;

export const StyledMain = styled.div`
    z-index: ${tokens.hero.zindex.main};
    position: relative;
`;

export const StyledInterior = styled.div<StyledInteriorProps>`
    position: relative;
    display: grid;
    grid-auto-flow: column;
    gap: ${tokens.hero.interior.gap}px;
    top: var(--yat_nft-card-hero-interior-padding-top);
    bottom: var(--yat_nft-card-hero-interior-padding-bottom);
    width: calc(100% - ${tokens.hero.interior.padding * 2}px);
    height: 0;

    ${StyledFooter} & {
        align-content: end;
        align-items: end;
    }

    ${({ $alignment }) => {
        if ($alignment === NftCardHeroInteriorAlignment.Right) {
            return css`
                justify-content: end;
                justify-items: end;
            `;
        }

        if ($alignment === NftCardHeroInteriorAlignment.Center) {
            return css`
                justify-content: center;
                justify-items: center;
            `;
        }

        if ($alignment === NftCardHeroInteriorAlignment.SpaceBetween) {
            return css`
                justify-content: space-between;
                justify-items: space-between;
            `;
        }
    }};

    // TODO: We may want to consider a "stack" variant:
    // grid-auto-flow: row;
`;
